export default __webpack_public_path__ + "static/Plots0001-a6ea662cebf8e2b730ce2531c0fa5914.jpg";